var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          class: [
            _vm.bemBlockMod(
              ((_obj = {}),
              (_obj[_vm.type] = _vm.type),
              (_obj["is-invalid"] = _vm.isInvalid),
              _obj)
            ),
            "form__field",
            "form-group",
            _vm.alwaysFloatingLabel
              ? "interaction--always-floating-label"
              : "interaction--floating-label"
          ]
        },
        [
          _c(
            "input",
            _vm._g(
              {
                ref: "input",
                class: [
                  _vm.bemElement("input"),
                  "input",
                  "input--" + _vm.type,
                  _vm.classInput,
                  "form-control",
                  { "is-invalid": _vm.isInvalid }
                ],
                attrs: {
                  id: _vm.id,
                  "aria-required": _vm.required.toString(),
                  autocomplete: _vm.autocomplete,
                  disabled: _vm.disabled,
                  readonly: _vm.readonly,
                  name: _vm.name,
                  min: _vm.min,
                  max: _vm.max,
                  maxlength: _vm.maxlength > 0 ? _vm.maxlength : "",
                  minlength: _vm.minlength > 0 ? _vm.minlength : "",
                  pattern: _vm.pattern,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  type: _vm.inputType,
                  "data-pattern-mismatch": _vm.errorMessages.patternMismatch,
                  "data-range-error": _vm.errorMessages.rangeError,
                  "data-missing-error":
                    _vm.dataMissingError || _vm.errorMessages.missingError
                },
                domProps: { value: _vm.value },
                on: { invalid: _vm.handleInvalid }
              },
              _vm.inputListeners
            )
          ),
          _vm._v(" "),
          !_vm.hideLabel
            ? _c(
                "label",
                {
                  class: [_vm.bemElement("label"), _vm.classLabel],
                  attrs: { for: _vm.id }
                },
                [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: [_vm.bemElement("error-message"), "invalid-feedback"] },
            [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]
          ),
          _vm._v(" "),
          _vm.helpText
            ? _c("p", { staticClass: "form__message" }, [
                _vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }